import React from "react";
import { Form, Input, Spin } from "antd";
import { map, range } from "lodash";
import { DropdownInput } from "components";
import { EComModal } from "components/EComModal";
import { AiccCanDoStatement, AiccCanDoStatementPayload } from "types/model/aiccLearningAssets";
import { trimValues, useAssetFormModal } from "../hooks/useAssetFormModal";
import styles from "../LearningAssets.module.scss";

const FLUENCY_LEVEL_COUNT = 10;

const FLUENCY_LEVEL_OPTIONS = map(range(1, FLUENCY_LEVEL_COUNT + 1), (level) => ({
  label: String(level),
  value: level,
}));

interface Props {
  visible: boolean;
  statement?: AiccCanDoStatement;
  isSaving: boolean;
  onCancel: () => void;
  onSubmit: (payload: AiccCanDoStatementPayload) => void;
}

const toFormValues = (statement?: AiccCanDoStatement) => ({
  fluencyLevel: statement?.fluencyLevel,
  statement: statement?.statement,
});

function CanDoStatementModal({ visible, statement, isSaving, onCancel, onSubmit }: Props) {
  const form = useAssetFormModal<AiccCanDoStatementPayload, AiccCanDoStatement>(visible, statement, toFormValues);
  const isEditing = !!statement;

  const handleOk = () => form.validateFields().then((values) => onSubmit(trimValues(values)));

  return (
    <EComModal
      visible={visible}
      title={isEditing ? "Edit Can-do Statement" : "Add Can-do Statement"}
      okText="Save"
      onOk={handleOk}
      onCancel={onCancel}
      isSaving={isSaving}
    >
      <Spin spinning={isSaving} size="large">
        <Form form={form} layout="vertical">
          <Form.Item
            className={styles.dropdownFormItem}
            label="Fluency Level"
            name="fluencyLevel"
            rules={[{ required: true, message: "Please select a fluency level." }]}
          >
            <DropdownInput options={FLUENCY_LEVEL_OPTIONS} placeholder="Fluency Level" mode="single" />
          </Form.Item>
          <Form.Item
            label="Statement"
            name="statement"
            rules={[{ required: true, message: "Please enter a statement." }]}
          >
            <Input.TextArea rows={4} showCount placeholder="Can order food at a restaurant" />
          </Form.Item>
        </Form>
      </Spin>
    </EComModal>
  );
}

export default CanDoStatementModal;
